import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AIAgentVisual from '../assets/ai面试官.png';
import '../styles/ai-family.css';
import useRevealAnimation from '../hooks/useRevealAnimation';
import useDocumentTitle from '../hooks/useDocumentTitle';

const AIFamily: React.FC = () => {
    const { t } = useTranslation();
    const pageRef = useRef<HTMLDivElement>(null);

    useRevealAnimation(pageRef);
    useDocumentTitle(t('Header.nav.ai'));

    return (
        <div className="ai-family-page" ref={pageRef}>
            <section className="ai-family-hero">
                <div className="ai-family-hero-bg">
                    <div className="ai-family-grid" />
                    <div className="ai-family-glow" />
                    <div className="ai-family-noise" />
                </div>

                <div className="section-container ai-family-hero-content">
                    <div className="ai-family-hero-copy reveal">
                        <div className="ai-family-visual-shell">
                            <div className="ai-family-visual-ring" aria-hidden="true" />
                            <div className="ai-family-visual-card">
                                <img
                                    src={AIAgentVisual}
                                    alt={t('AIFamily.hero.imageAlt')}
                                    className="ai-family-visual-image"
                                />
                            </div>
                        </div>

                        <span className="ai-family-kicker">{t('AIFamily.hero.kicker')}</span>
                        <h1 className="ai-family-hero-title">{t('AIFamily.hero.title')}</h1>
                        <p className="ai-family-hero-subtitle">{t('AIFamily.hero.subtitle')}</p>

                        <div className="ai-family-hero-actions">
                            <button type="button" className="ai-family-hero-button is-disabled" disabled aria-disabled="true">
                                {t('AIFamily.hero.comingSoon')}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AIFamily;
